import LikeCountBadge from './LikeCountBadge';
import { ACTIVITY_DETAILS_RADIUS, ACTIVITY_DETAILS_RESPONSIVE } from './constants';

interface ActivityImageProps {
  imageUrl: string;
  title: string;
  likesCount: number;
}

/**
 * ActivityImage Component
 * 
 * Activity hero image with like count overlay badge.
 * Responsive: Scales height and maintains aspect ratio across breakpoints.
 * 
 * Design specs:
 * - Position: responsive padding from container
 * - Dimensions: 100% width, height scales (197px → 240px → 280px)
 * - Border radius: 12px
 * - Object fit: cover
 * - Like badge: bottom-right, 8px from edges
 */
export default function ActivityImage({ imageUrl, title, likesCount }: ActivityImageProps) {
  return (
    <div
      className={`relative overflow-hidden mt-1 mx-6 sm:mx-8 md:mx-10 lg:mx-12 ${ACTIVITY_DETAILS_RESPONSIVE.imageHeightClasses}`}
      style={{
        borderRadius: `${ACTIVITY_DETAILS_RADIUS.image}px`,
      }}
    >
      {/* Image */}
      <img
        src={imageUrl}
        alt={title}
        className="w-full h-full object-cover"
      />

      {/* Like Count Badge */}
      {
        likesCount > 0 && (
          <LikeCountBadge
            count={likesCount}
            className="absolute bottom-2 right-2"
          />
        )
      }
    
    </div>
  );
}
